import { render, staticRenderFns } from "./increase.vue?vue&type=template&id=c6013c3e&scoped=true&"
import script from "./increase.vue?vue&type=script&lang=js&"
export * from "./increase.vue?vue&type=script&lang=js&"
import style0 from "./increase.vue?vue&type=style&index=0&id=c6013c3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6013c3e",
  null
  
)

export default component.exports